import { graphql } from "gql";

const HAPPYCO_CREATE_WORK_ORDER_MUTATION = graphql(`
  mutation HappycoCreateWorkOrder($input: HappycoCreateWorkOrderInput!) {
    happycoCreateWorkOrder(input: $input) {
      ...HappycoWorkOrder
    }
  }
`);

export default HAPPYCO_CREATE_WORK_ORDER_MUTATION;
